import { createSlice } from '@reduxjs/toolkit';

import type { ComarcaState } from '@/types/comarca/comarcaTypes';

import { buscarComarcasPorTribunal, listarComarcas } from './actions';

const initialState: ComarcaState = {
  comarcas: [],
  loading: false,
  error: null,
  total: 0,
  page: 1,
  limit: 100,
};

const comarcaSlice = createSlice({
  name: 'comarca',
  initialState,
  reducers: {
    clearComarcas: (state) => {
      state.comarcas = [];
      state.total = 0;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(listarComarcas.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(listarComarcas.fulfilled, (state, action) => {
        state.loading = false;
        state.comarcas = action.payload.data;
        state.total = action.payload.total;
        state.page = action.payload.page;
        state.limit = action.payload.limit;
      })
      .addCase(listarComarcas.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'Erro ao listar comarcas';
      })
      .addCase(buscarComarcasPorTribunal.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(buscarComarcasPorTribunal.fulfilled, (state, action) => {
        state.loading = false;
        state.comarcas = action.payload;
      })
      .addCase(buscarComarcasPorTribunal.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'Erro ao buscar comarcas';
      });
  },
});

export const { clearComarcas } = comarcaSlice.actions;
export default comarcaSlice.reducer;
